import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../utils/Constants";
import Swal from "sweetalert2";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";



const LeadContent = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    let id: any = searchParams.get("id");
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: "",
        email: "",
        mobile: "",
        name: "",
        campaign_id: 0
        
    });
    const handleAddLead = (e: any) => {
        e.preventDefault();
        axios.post(`${BASE_URL}/marktingfunctions/savelead.php`, formData).then((res) => {
            Swal.fire("Success", "Lead saved successfully", "success").then(() => {
                navigate(`/leads`);
            })
        }).catch((err) => {
            Swal.fire("Error",err.response.data.msg , "error")
        })
    }

    const [campaigns, setCampaigns] = useState([]);
    

    useEffect(() => {
        if (id != 0) {

            axios.get(`${BASE_URL}/marktingfunctions/getlead.php?id=${id}`).then((res) => {
                setFormData(res.data.data)
            })
        }
        axios.get(`${BASE_URL}/marktingfunctions/getutils.php`).then((res) => {
            setCampaigns(res.data.data)
        })
        
    }, [])

    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        setFormData((prevState: any) => ({ ...prevState, [name]: value }));
    };
    return (
        <div>
            <NavLink to={"/leads"} className="btn btn-secondary"><i className="bi bi-arrow-left" style={{color:"white"}}></i></NavLink>
            <h2>Add lead </h2>
            <form onSubmit={handleAddLead}>
                <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">Email </label>
                    <input type="email" name="email" value={formData.email} required onChange={handleChange} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />

                </div>
                <div className="mb-3">
                    <label htmlFor="name" className="form-label">Display name </label>
                    <input type="text" name="name" value={formData.name} required onChange={handleChange} className="form-control" id="name" />
                </div>
                <div className="mb-3">
                    <label htmlFor="mobile" className="form-label">Mobile</label>
                    <input type="text" name="mobile" value={formData.mobile} required onChange={handleChange} className="form-control" id="mobile" />
                </div>
                <div className="mb-3">
                <label htmlFor="role" className="form-label">Campaign </label>

                    <select className="form-select" name="campaign_id" onChange={handleChange} required  aria-label="Default select example">
                       <option value="">Select campaign</option>
                       {campaigns.map((campaign: any) => {
                        return (
                            <option value={campaign.id} selected={formData.campaign_id == campaign.id}>{campaign.name}</option>
                        )
                    })}
                       
                       
                       
                    </select>
                </div>
<div className="text-center">

                <button className="btn btn-success" >Submit</button>
</div>
            </form>
        </div>
    )
}


export default LeadContent